"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resultDataBuilder = void 0;
var resultDataBuilder = function (value, options) {
    if (!options) {
        return undefined;
    }
    if (Array.isArray(value)) {
        var r = options.filter(function (o) { return value.indexOf(o.value) !== -1; });
        return r.length === 0 ? undefined : r;
    }
    return options.filter(function (o) { return o.value === value; }).pop();
};
exports.resultDataBuilder = resultDataBuilder;
//# sourceMappingURL=resultDataBuilder.js.map